<template>
  <v-dialog v-model="localValue" scrollable width="800" lazy persistent>
    <v-card>
      <v-toolbar color="primary" dense dark>
        <v-toolbar-title>
          {{
            $t(`titles.global.${schedule ? 'updateModel' : 'newModel'}`, {
              field: $tc('models.recordingSchedule'),
            })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="py-0">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md6 sm6 xs12 px-2>
              <v-select
                v-model="localSchedule.dayOfWeek"
                v-validate="'required'"
                :data-vv-name="$t('fields.global.dayOfWeek')"
                :error-messages="errors.collect($t('fields.global.dayOfWeek'))"
                :items="daysOfWeek"
                :label="$t('fields.global.dayOfWeek')"
              />
            </v-flex>

            <v-flex md6 xs12 px-2>
              <v-menu
                ref="menuStartTime"
                v-model="menuStartTime"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="localSchedule.startTime"
                    v-validate="'required'"
                    readonly
                    :label="$tc('fields.global.startTime') + ' (*)'"
                    :data-vv-name="$tc('fields.global.startTime')"
                    :error-messages="
                      errors.collect($tc('fields.global.startTime'))
                    "
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuStartTime"
                  v-model="localSchedule.startTime"
                  full-width
                  @change="onChangeStartTime"
                  @click:minute="
                    $refs.menuStartTime.save(localSchedule.startTime)
                  "
                />
              </v-menu>
            </v-flex>

            <v-flex md6 xs12 px-2>
              <v-menu
                ref="menuEndTime"
                v-model="menuEndTime"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="localSchedule.endTime"
                    v-validate="'required'"
                    readonly
                    :label="$tc('fields.global.endTime') + ' (*)'"
                    :data-vv-name="$tc('fields.global.endTime')"
                    :error-messages="
                      errors.collect($tc('fields.global.endTime'))
                    "
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuEndTime"
                  v-model="localSchedule.endTime"
                  full-width
                  @change="onChangeEndTime"
                  @click:minute="$refs.menuEndTime.save(localSchedule.endTime)"
                />
              </v-menu>
            </v-flex>

            <v-flex md1 xs12 px-2>
              <v-switch
                v-model="localSchedule.active"
                :label="$t('fields.global.active')"
                color="primary"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <template>
          <span style="color: red">(*) &nbsp;</span>
          <span>{{ $t('action.messages.fieldRequired') }}</span>
        </template>
      </v-card-actions>
      <v-card-actions>
        <v-spacer />
        <meta-button type="reset" @click="clear" />
        <meta-button type="cancel" @click="cancel" />
        <meta-button :type="schedule ? 'update' : 'create'" @click="submit" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogRecordingSchedule',
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
    schedule: null,
  },
  data() {
    return {
      localSchedule: {
        active: false,
        dayOfWeek: '',
        startTime: '',
        endTime: '',
      },
      menuStartTime: false,
      menuEndTime: false,
    }
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    daysOfWeek() {
      return [
        { text: this.$t('fields.global.daysOfWeek.0'), value: 0 },
        { text: this.$t('fields.global.daysOfWeek.1'), value: 1 },
        { text: this.$t('fields.global.daysOfWeek.2'), value: 2 },
        { text: this.$t('fields.global.daysOfWeek.3'), value: 3 },
        { text: this.$t('fields.global.daysOfWeek.4'), value: 4 },
        { text: this.$t('fields.global.daysOfWeek.5'), value: 5 },
        { text: this.$t('fields.global.daysOfWeek.6'), value: 6 },
      ]
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.schedule) {
          this.localSchedule = { ...this.schedule }
        }
      } else this.clear()
    },
  },
  methods: {
    onChangeStartTime(time) {
      if (time) {
        this.$nextTick(() => {
          this.localSchedule.startTime = time
          if (this.$refs.startTime) {
            this.$refs.startTime.lazyValue = time
          }
        })
      }
    },
    onChangeEndTime(time) {
      if (time) {
        this.$nextTick(() => {
          this.localSchedule.endTime = time
          if (this.$refs.endTime) {
            this.$refs.endTime.lazyValue = time
          }
        })
      }
    },
    submit() {
      this.validate()
        .then((valid) => {
          if (!valid) return

          this.$emit('submit', this.localSchedule)
        })
        .catch(() => {})
    },
    clear() {
      this.localSchedule = {
        active: true,
        dayOfWeek: '',
        startTime: '',
        endTime: '',
      }
      this.$validator.pause()
      this.nextTick(() => {
        this.$validator.reset()
        this.$validator.resume()
      })
    },
    cancel() {
      this.localValue = false
      this.clear()
      this.$emit('cancel')
    },
  },
}
</script>
